/**
 * File utility functions
 */

/**
 * Validates if a string is a valid URL
 */
export function validateUrl(url) {
  if (!url || typeof url !== 'string') return false;

  // Check if it's a data URL (base64)
  if (url.startsWith('data:')) return true;

  // Check if it's a blob URL
  if (url.startsWith('blob:')) return true;

  // Check if it's an HTTP/HTTPS URL
  try {
    const urlObj = new URL(url);
    return urlObj.protocol === 'http:' || urlObj.protocol === 'https:';
  } catch {
    return false;
  }
}

/**
 * Extracts filename from a URL
 */
export function getFilenameUrl(url) {
  if (!url) return '';

  try {
    const urlObj = new URL(url);
    const pathname = urlObj.pathname;
    const filename = pathname.split('/').pop();
    return filename || '';
  } catch {
    // If it's not a valid URL, try to extract from string
    return url.split('/').pop() || '';
  }
}

/**
 * Formats file size to human readable format
 */
export function getFileSizeFormat(bytes) {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
}

/**
 * Gets accept file types based on type string
 */
export function getAcceptFile(type) {
  const acceptTypes = {
    image: ['image/*'],
    audio: ['audio/*'],
    video: ['video/*'],
    zip: ['.zip', '.rar', '.7z', 'application/zip', 'application/x-rar-compressed'],
  };

  return acceptTypes[type] || [];
}
